<template>
  <invoice-preview
  :invoice="invoice"
  :imageUrl="invoice.logo"
  :invoicedDateFormatted="this.formatDate(invoice.invoiced_date)"
  pdf="pdf"></invoice-preview>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'

import { formatDate } from '@/components/Mixins/formatDate'
import InvoicePreview from '@/components/Invoice/InvoicePreview'

export default {
  name: 'InvoicePDF',
  components: {
    InvoicePreview
  },
  mixins: [formatDate],
  data () {
    return {
      showPay: false,
      itemId: this.$route.params.invoice_id,
      groupId: this.$route.params.group_id,
      customerEmail: this.$route.query.e,
      complete: false,
      invoiceIsPaid: false,
      invoice: {
        id: '',
        title: '',
        clientName: '',
        amount: '',
        contact: '',
        invoice_ref: '',
        invoiced_date: '',
        paid_date: '',
        chargeTax: false,
        taxRate: '',
        clientAddress: '',
        postCode: '',
        groupTitle: '',
        groupAddress: '',
        logo: '',
        logoWidth: 120,
        logoAlign: 'center',
        paymentTerms: '',
        totalNet: 0,
        totalTax: 0,
        totalGross: 0,
        lineItems: [],
        status: 'Unsent'
      }
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    async fetchData () {
      // check for existing invoice, if so grab all items from this
      try {
        this.$store.commit('setLoading', true)
        const getCustomerInvoice = firebase.functions().httpsCallable('getCustomerInvoice')
        const response = await getCustomerInvoice({ groupId: this.$route.params.group_id, invoiceId: this.$route.params.invoice_id })
        this.invoice = response.data
        this.$store.commit('setLoading', false)
      } catch (error) {
        this.$store.commit('setError', error)
        this.$store.commit('setLoading', false)
      }
    },
    logRead () {
      const readMsg = {
        created: Date.now(),
        status: 'Downloaded'
      }
      firebase.database().ref('invoices-activity/' + this.$route.params.group_id + '/' + this.$route.params.invoice_id).push(readMsg)
        .then((data) => {
        })
        .catch((error) => {
          this.$store.commit('setError', error)
          this.$store.commit('setLoading', false)
        })
    }
  },
  created () {
    this.fetchData()
    this.logRead()
  }
}
</script>

<style lang="scss">
h1{
  width:100%;
  display:block;
}
</style>
